/**
 * Committee Section Component
 * Displays a corporate governance committee with its members
 * Used in the Corporate Governance page
 */
import React from 'react'
import styled from '@emotion/styled'

interface CommitteeSectionProps {
  name: string
  members: Array<{ zhHant: string; en: string }>
  langKey: string
}

const SectionWrapper = styled.div`
  width: calc(100% / 3);
  margin: 2rem 0;

  @media (max-width: 767px) {
    width: calc(100% / 2);
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`

const CommitteeTitleWrapper = styled.div`
  left: 2rem;
  margin-right: 2rem;
  position: relative;
  min-height: 3.5rem;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    left: 0;
    margin-right: 1rem;
    min-height: 3rem;
  }
`

const CommitteeName = styled.span`
  font-size: 1.4rem;
  color: #ff6637;

  @media (max-width: 767px) {
    font-size: 1.05rem;
  }
`

const TitleRule = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin: 1rem 0;
`

const RuleMarker = styled.div`
  background: #ff6637;
  width: 6px;
  height: 9px;
  margin-bottom: 0.2rem;
  margin-left: 26px;

  @media (max-width: 767px) {
    margin-left: 0;
  }
`

const RuleLine = styled.div`
  flex: 1;
  height: 9px;
  margin-left: 14px;
  margin-bottom: 0.2rem;
  background: #f5f5f5;
`

const MemberList = styled.ul`
  list-style: none;
  margin: 1rem 0;
  color: #666;
  line-height: 1.7;
  padding-left: 40px;

  @media (max-width: 767px) {
    padding-left: 0;
    font-size: 0.9rem;
  }
`

const MemberItem = styled.li`
  margin: 0.5rem 0;
  color: #666;
`

const CommitteeSection: React.FC<CommitteeSectionProps> = ({ name, members, langKey }) => {
  const lang = langKey === 'zhHant' ? 'zhHant' : 'en'

  return (
    <SectionWrapper>
      <CommitteeTitleWrapper>
        <CommitteeName>{name}</CommitteeName>
      </CommitteeTitleWrapper>
      <TitleRule>
        <RuleMarker />
        <RuleLine />
      </TitleRule>
      <MemberList>
        {members.map((member, index) => (
          <MemberItem key={index}>{member[lang]}</MemberItem>
        ))}
      </MemberList>
    </SectionWrapper>
  )
}

export default CommitteeSection
